import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgNightLife(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M3.24189 4.31083C2.59675 3.31255 3.3177 2 4.51117 2H19.4888C20.6823 2 21.4032 3.31255 20.7581 4.31083L19.0203 7H4.97975L3.24189 4.31083Z", fill: "currentColor" }),
        React.createElement("path", { d: "M6.27224 9L10.9942 16.3067V20H6.0058C5.45031 20 5 20.4477 5 21C5 21.5523 5.45031 22 6.0058 22H17.9942C18.5497 22 19 21.5523 19 21C19 20.4477 18.5497 20 17.9942 20H13.0058V16.3068L17.7278 9H6.27224Z", fill: "currentColor" })));
}
export default SvgNightLife;
